import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { BreadCrumbs } from '../../shared/breadCrumbs/BreadCrumbs';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { getAsset } from '../../actions/assetAction';
import { AssetDropDown } from '../../UiComponents/AssetDropDown';
import { getAssestListddlAction } from '../../actions/assetsddlAction';
import { getAssetSettings, getBenchmarkEntities } from '../../actions/assetSettingsAction';
import { AgGridReact } from 'ag-grid-react';
import { UrlPath } from '../../../config/routeConfig';
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import { sbaAxios } from '../../utils/sbaAxios';
import './AssetSettings.css';
import { DeleteAssetBMSetting, InsertAssetBMSetting} from "../../../config/apiConfig";
import { SBAAutoComplete, SBAComboBox, SBADropDown, SBAMultiColumnComboBox } from "../../UiComponents/SBADropDown";
import { getBenchmarkEntity } from '../../../config/apiConfig';


export const AssetSettingsPage = () => {
    const isEditable=useSelector(state=>state.authorizationData.isEditable);
    const params = useParams();
    const dispatch = useDispatch();
     const history = useNavigate();
    const [torender, SetToRender] = useState(false);
    const [Loading, setLoading] = useState(true);
    const [SelectedBM, setSelectedBM] = useState([]);
    const [totalBM, setTotalBM] = useState([]);
    const [initalRender, setInitalRender] = useState(true);
    const selectedBMApi = useRef();
    const TotalBMApi = useRef();
    const [MARBM, setMARBM] = useState();
    const [RFRBM, setRFRBM] = useState();
    const [RFRValue, setRFRValue] = useState({
        isFixed: true, fValue: null, VariableValue: {
            "BenchmarkEntityId": 0,
            "BenchmarkEntityName": "",
            "BenchmarkEntityTypeId": 0,
            "BenchmarkEntityType": "",
            "StartDate": "",
            "EndDate": null
        }
    });
    const [MARValue, setMARValue] = useState({ isFixed: true, fValue: 0, VariableValue: {
        "BenchmarkEntityId": 0,
        "BenchmarkEntityName": "",
        "BenchmarkEntityTypeId": 0,
        "BenchmarkEntityType": "",
        "StartDate": "",
        "EndDate": null
    }});

    useEffect(() => {
        document.title = "Asset Settings";
        dispatch(getAssestListddlAction());
        dispatch(getAsset(params.Asset));
        dispatch(getAssetSettings(params.Asset,1));
    }, [torender]);

   
    const CancelButtonClick = () => {
      
        history(`${UrlPath.AssetDetails}${params.Asset}`);
    };

    const Gstate = useSelector((state) => state);
    const currentAsset = Gstate.asset.asset;
    const AssetListDDL = useSelector(state => state.assetDDL.assetList);
    const AssetSettings = useSelector(state => state.assetSettings);
    const benchmarkEntities = AssetSettings.benchMarkEntities;
    const additionalBM = AssetSettings.additionalBM;
    const ASetting = AssetSettings.assetSetting || {};
    const assetBM = AssetSettings.assetSetting.Benchmarks || [];

    useEffect(() => {
    }, [assetBM])


    useEffect(() => {
        if (initalRender == true) {
            setInitalRender(false)
            return;
        }

        setTotalBM(() => benchmarkEntities);
        setRFRBM(() => additionalBM);
        setMARBM(() => additionalBM);
    }, [benchmarkEntities, additionalBM]); 
    
    useEffect(() => {
        setSelectedBM(assetBM.map((item, index) => {
            return { ...item , AssetId : parseInt(params.Asset)  ,"rowIndex": index ,EntityTypeId:1 ,BenchMarkXRefId :0 ,ModifiedBy :32 }
        }));
        setRFRValue({
            isFixed: ASetting.IsRFRFixedRate, fValue: ASetting.RFR, VariableValue: 
            {
                "BenchmarkEntityId": ASetting.RFRBenchmark,
                "BenchmarkEntityName": ASetting.RFRBenchmarkName,
                "BenchmarkEntityTypeId": ASetting.RFREntityTypeId,
                "BenchmarkEntityType": "",
                "StartDate": "",
                "EndDate": null
            }
        });
        setMARValue({
            isFixed: ASetting.IsMARFixedRate, fValue: ASetting.MAR, VariableValue: 
            {
                "BenchmarkEntityId": ASetting.MARBenchmark,
                "BenchmarkEntityName": ASetting.MARBenchmarkName,
                "BenchmarkEntityTypeId":  ASetting.MAREntityTypeId,
                "BenchmarkEntityType": "",
                "StartDate": "",
                "EndDate": null
            }
        });
    }, [ASetting]);
    useEffect(() => {
        (currentAsset && AssetListDDL && AssetSettings) && setLoading(false);
    }, [Gstate]);

    const AssestDDChanged = async (e) => {
        if (e.value) {
            await e.value && history(`${UrlPath.AssetSetting}${e.value.AssetId}`);
            await e.value && dispatch(getAsset(e.value.AssetId));
            await e.value && dispatch(getAssetSettings(e.value.AssetId,1));
        }
    }
    const endDatevalueFormatter = (props) => {
        const date = props.data.EndDate;
        let monthName = "";
        let year = "";
        let convertedDate;
        let outPut = "";
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        if (date !== null) {
            convertedDate = new Date(date);
            monthName = monthNames[convertedDate.getMonth()];
            year = convertedDate.getFullYear();
            outPut = monthName + "-" + year;
        }
        return (
            <div>{outPut
            }</div>
        );
    };


    const startDatevalueFormatter = (props) => {
        const date = props.data.StartDate;
        let monthName = "";
        let year = "";
        let convertedDate;
        let outPut = "";
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        if (date !== null) {
            convertedDate = new Date(date);
            monthName = monthNames[convertedDate.getMonth()];
            year = convertedDate.getFullYear();
            outPut = monthName + "-" + year;
        }
        return (
            <div>{outPut
            }</div>
        );
    };
    const totalBMcolDef = [
        { field: "rowNumber", headerName: "", valueGetter: 'node.rowIndex+1', flex: 0.2 },
        { field: "BenchmarkEntityName", headerName: "Name", flex: 2, resizable: true },
        { field: "BenchmarkEntityType", headerName: "Entity Type" },
        { field: "StartDate", headerName: "Start Date", cellRenderer: startDatevalueFormatter },
        { field: "EndDate", headerName: "End Date", cellRenderer: endDatevalueFormatter },
    ];

    const selectedBMcolDef = [
        {
            rowDrag: true,
            field: "", headerName: "Selected", width: 110, valueGetter: function (params) {
                const rowIndex = params.node.rowIndex + 1;
                const IsPME = params.data.BenchMarkXRefTypeId == 4;
                if (rowIndex == 1) {
                    if (IsPME)
                        return "PME ";
                    else
                        return "Primary";
                }
                else if (rowIndex == 2) {
                    if (IsPME)
                        return "PME";
                    else
                        return "Secondary";
                }
                else {
                    if (IsPME)
                        return `PME`;
                    else
                        return `Addl BM ${rowIndex - 2}`;
                }
            },
            flex: 1.5
        },
        { field: "BMEntityName", headerName: "Name", flex: 2 },
        { field: "BenchmarkTypeName", headerName: "Entity Type", },
        { field: "StartDate", headerName: "Start Date", cellRenderer: startDatevalueFormatter, },
        { field: "EndDate", headerName: "End Date", cellRenderer: endDatevalueFormatter },
    ];

    const defaultColDef = {
        sortable: true, filter: true, flex: 1,resizable:true
    }
    const changeSearchTerm = (e) => {
        const search = e.target.value;
        search.length > 0 && dispatch(getBenchmarkEntities(search, "benchMark"));
        search.length === 0 && setTotalBM([]);
    }
    const getAdditionalBM = (e) => {
        const search = e.filter.value;
        search.length > 3 && dispatch(getBenchmarkEntities(search, "AdditionalbenchMark"));
    }
    const addBenchMark = (e) => {     
        const newBenchMark = TotalBMApi.current.api.getSelectedRows();
        if(newBenchMark.length>0){
            newBenchMark && addSelectedBM(newBenchMark[0]);
        }
        // if (SelectedBM.length > 0) {
        //     let RepeatedBenchmark = [];
        //     SelectedBM.map((item) => {
        //         const newBenchMarklist = item;
        //         const BenchmarkEntityName = item.EntityName;
        //         if (newBenchMark.BenchmarkEntityId === newBenchMarklist.BMEntityId) {
        //             RepeatedBenchmark.push(`${BenchmarkEntityName}`);
        //         }
        //     })
        //     if (RepeatedBenchmark.length > 0) {
        //         let ErrorString = "";
        //         RepeatedBenchmark.map((item, i) => {
        //             ErrorString = `${ErrorString}  ${item} ,  `;
        //         });
        //         ErrorString = `${ErrorString} already Exists`;
        //         toast.error(ErrorString, {
        //             position: "top-right",
        //             autoClose: 5000,
        //             hideProgressBar: false,
        //             closeOnClick: true,
        //             pauseOnHover: false,
        //             draggable: true,
        //             progress: undefined,
        //             theme: "light",
        //         });
        //     }
        //     else {
        //         newBenchMark && addSelectedBM(newBenchMark);
        //     }

        // }
    }
    const addSelectedBM = (newBenchMark) => {
        const toAdd = {
            'rowIndex': SelectedBM.length,
            "AssetId": parseInt(params.Asset),
            "BenchMarkXRefId": 0,
            "BenchMarkXRefTypeId": 0,
            "BenchmarkTypeName": newBenchMark.BenchmarkEntityType,
            "EntityTypeId": 1,
            "EntityTypeName": null,
            "EntityId": parseInt(params.Asset),
            "BMEntityName": newBenchMark.BenchmarkEntityName,
            "IsFixedRate": false,
            "BMEntityTypeId": newBenchMark.BenchmarkEntityTypeId,
            "BMEntityTypeName": newBenchMark.BenchmarkEntityType,
            "BMRanking": "primary",
            "BMEntityId": newBenchMark.BenchmarkEntityId,
            "BMValue": 0,
            "IsMrktEqBM": false,
            "SortOrder": SelectedBM.length,
            "StartDate": newBenchMark.StartDate,
            "EndDate": newBenchMark.EndDate,
            "RFRBenchmark": null,
            "RFRBenchmarkName": null,
            "MARBenchmark": null,
            "MARBenchmarkName": null,
            "RFR": null,
            "MAR": null,
            "ModifiedBy": 32,
            "ModifiedByName": null,
            "ModifiedDate": (new Date()).toISOString,
        };
        if(SelectedBM.length<10)
        {
        setSelectedBM((pv) => {
        return [...pv, { ...toAdd }] });
        }
        else
        {   
            toast.error("Cannot add more than 10 benchmarks", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
    }
    const removeSelectedBM = (benchMark) => {
        setSelectedBM(pv => ((pv.filter(item => item.rowIndex !== benchMark.rowIndex).map((item, index) => { return { ...item, rowIndex: index, SortOrder: index } }))));
    }
    const BMGridRowDoubleClicked = (e) => {
        addSelectedBM(e.data);
    }
    const removeBenchMark = () => {
        const BenchMark = selectedBMApi.current.api.getSelectedRows()[0];
        BenchMark && removeSelectedBM(BenchMark);
    }
    const SBMGridRowDoubleClicked = (row) => {
        removeSelectedBM(row.data);
    }
    let Level = [{ BreadCrumb: "Asset > ", Routes: `${UrlPath.Asset}` }];
    Level = Loading ? Level : [...Level, { BreadCrumb: `${currentAsset.AssetName} >`, Routes: `${UrlPath.AssetDetails}${params.Asset}` }, { BreadCrumb: `Settings`, Routes: `${UrlPath.AssetSetting}${params.Asset}` }];

    const handleRowDragEnd = (params) => {
        // console.log(params,selectedBMApi.current.props.rowData,'params');
        // const rows = [];
        // selectedBMApi.current.api.forEachNodeAfterFilterAndSort((node,index) => {
        //     // node.data.rowIndex=index;
        //     // if(node.data.sortOder!==0)
        //     // {
        //     // node.data.SortOrder=index;
        //     // }
        //     rows.push(node.data)}
        //     );
        //     setSelectedBM(rows);
        const rows = [];
        selectedBMApi.current.api.forEachNodeAfterFilterAndSort((node) => rows.push(node.data));
        const OrderedRows=rows.map((data,index)=>{
            if(data.BenchMarkXRefTypeId===4)
            {
            data.rowIndex=99; 
            data.SortOrder=99;
            }
            else
            {
            data.rowIndex=index; 
            data.SortOrder=index;
            }
            return{...data}
            }).sort((a, b) => a.rowIndex - b.rowIndex) 
        setSelectedBM(OrderedRows);
    };
    const saveSelectedBM = async () => {
        let saveSuccess = true;
        let errorMsg = [];
        let bmItems = [...SelectedBM];
        bmItems.push({
            "rowIndex": 11,
            "AssetId": parseInt(params.Asset),
            "BenchMarkXRefId": 0,
            "BenchMarkXRefTypeId": 1,
            "BenchmarkTypeName": null,
            "EntityTypeId": 1,
            "EntityTypeName": null,
            "EntityId": parseInt(params.Asset),
            "EntityName": null,
            "IsFixedRate": RFRValue.isFixed,
            "BMEntityTypeId": RFRValue.isFixed ? 0 : RFRValue.VariableValue.BenchmarkEntityTypeId ,
            "BMEntityTypeName": RFRValue.isFixed ? 0 : RFRValue.VariableValue.BenchmarkEntityType,
            "BMRanking": null,
            "BMEntityId": RFRValue.isFixed ? 0 : RFRValue?.VariableValue?.BenchmarkEntityId,
            "BMEntityName": RFRValue.isFixed ? 0 : RFRValue?.VariableValue?.BenchmarkEntityName,
            "BMValue": RFRValue.isFixed ? parseFloat(RFRValue.fValue) : 0,
            "IsMrktEqBM": false,
            "SortOrder": 0,
            "StartDate": null,
            "EndDate": null,
            "RFRBenchmark": null,
            "RFRBenchmarkName": null,
            "MARBenchmark": null,
            "MARBenchmarkName": null,
            "RFR": null,
            "MAR": null,
            "ModifiedBy": 32,
            "ModifiedByName": null,
            "ModifiedDate": (new Date()).toISOString,
        });
        bmItems.push({
            "rowIndex": 12,
            "AssetId": parseInt(params.Asset),
            "BenchMarkXRefId": 0,
            "BenchMarkXRefTypeId": 2,
            "BenchmarkTypeName": null,
            "EntityTypeId": 1,
            "EntityTypeName": null,
            "EntityId": parseInt(params.Asset),
            "EntityName": null,
            "IsFixedRate": MARValue.isFixed,
            "BMEntityTypeId": MARValue.isFixed ? 0 : MARValue.VariableValue.BenchmarkEntityTypeId,
            "BMEntityTypeName": MARValue.isFixed ? 0 : MARValue.VariableValue.BenchmarkEntityType,
            "BMRanking": null,
            "BMEntityId": MARValue.isFixed ? 0 :  MARValue?.VariableValue?.BenchmarkEntityId,
            "BMEntityName": MARValue.isFixed ? 0 : MARValue?.VariableValue?.BenchmarkEntityName,
            "BMValue": MARValue.isFixed ? parseFloat(MARValue.fValue) : 0,
            "IsMrktEqBM": false,
            "SortOrder": 0,
            "StartDate": null,
            "EndDate": null,
            "RFRBenchmark": null,
            "RFRBenchmarkName": null,
            "MARBenchmark": null,
            "MARBenchmarkName": null,
            "RFR": null,
            "MAR": null,
            "ModifiedBy": 32,
            "ModifiedByName": null,
            "ModifiedDate": (new Date()).toISOString,
        });
        const newArray = bmItems.map(item => {
            return {
                "assetId": item.AssetId,
                "benchMarkXRefId": item.BenchMarkXRefId || 0,
                "benchMarkXRefTypeId": item.BenchMarkXRefTypeId || 0,
                "entityTypeId": item.EntityTypeId || 0,
                "entityId": item.EntityId || 0,
                "isFixedRate": item.IsFixedRate,
                "bmEntityTypeId": item.BMEntityTypeId || 0,
                "bmEntityId": item.BMEntityId || 0,
                "bmValue": item.BMValue || 0,
                "isMrktEqBM": item.IsMrktEqBM,
                "sortOrder": item.SortOrder || 0,
                "modifiedBy": item.ModifiedBy
            }

        });
        if (SelectedBM.length === 0) {
            saveSuccess = false;
            errorMsg.push("Please Select atleast one BenchMark");
        }
        if (RFRValue.isFixed) {
            if (RFRValue.fValue == null || RFRValue.fValue == "") {
                saveSuccess = false;
                errorMsg.push("Plesse Add RFR Type Value");
            }
        }
        else if (!RFRValue.isFixed) {
            if (!RFRValue.VariableValue.BenchmarkEntityId || RFRValue.VariableValue.BenchmarkEntityId === 0 ) {
                saveSuccess = false;
                errorMsg.push("Plesse Add RFR Variable Value");
            }
        }
        if (MARValue.isFixed) {
            if (MARValue.fValue == "" || MARValue.fValue == null) {
                saveSuccess = false;
                errorMsg.push("Plesse Add MAR Type Value");
            }
        }
        else if (!MARValue.isFixed) {
            if (!MARValue.VariableValue.BenchmarkEntityId || MARValue.VariableValue.BenchmarkEntityId === 0) {
                saveSuccess = false;
                errorMsg.push("Plesse Add MAR Variable Value");
            }
        }

        if (saveSuccess) {
            await sbaAxios({
                url: `${DeleteAssetBMSetting}${params.Asset},1`,
                method: 'get',
            }).then(response => {
            })
                .catch(error => {
                    console.error('Error deleting data:', error);
                });  
                await sbaAxios({
                    url: `${InsertAssetBMSetting}`,
                    method: 'post',
                    data: newArray,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }).then((response) => {
                    toast.success('Benchmark Added Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                }).catch((error) => { console.log(error) });
                setTimeout(() => {
                  
                    history(`${UrlPath.AssetDetails}${params.Asset}`);
                  }, 1000);
        }
        else {
            toast.error(errorMsg.join("\n "), {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
    };
    const setPME = (rowIndex) => {
        let sortOder = -1;
        const updatedBM= SelectedBM.map(item => {
            if (item.rowIndex == rowIndex)
                return {
                    ...item, BenchMarkXRefTypeId: 4,rowIndex:99 ,SortOrder: 99
                }
            else {
                sortOder++;
                return { ...item, BenchMarkXRefTypeId: 0, SortOrder: sortOder , rowIndex:sortOder }
            }
        }).sort((a, b) => a.rowIndex - b.rowIndex);
        setSelectedBM(updatedBM);
    }
    const removePME = (rowIndex) => {
        const updatedBM=SelectedBM.map((item,index) => {
                return { ...item, BenchMarkXRefTypeId: 0, SortOrder: index }
        }).sort((a, b) => a.SortOrder - b.SortOrder)
        setSelectedBM(updatedBM);
    }
    const getContextMenuItems = (params) => {
        const rowIndex = params.node.data.rowIndex;
        const isPME = params.node.data.BenchMarkXRefTypeId === 4;
        var setPMEMenu = [
            {
                name: 'Set PME',
                action: () => {
                    setPME(rowIndex);
                },
                cssClasses: ['benchmark', 'highlight', 'bold'],
            },
        ];
        var removePMEMenu = [
            {
                name: 'Set BM',
                action: () => {
                    removePME(rowIndex);
                },
                cssClasses: ['benchmark', 'highlight', 'bold'],
            },
        ];
        if (isPME)
            return removePMEMenu;
        else
            return setPMEMenu;
    };
    return (
        <>
            {Loading ? <><LoadingScreen /></> : <> 
            <TopBar label={"Asset Settings"} />
                <div 
                id="AssetSetting" 
                className='container-fluid px-3 mainContentData'
                >
                <BreadCrumbs Levels={Level} />
                    <div className='headingGroup d-flex flex-column'>
                        <div className='lineDiv'>
                            <label id="WarningLabel"></label>
                        </div>
                        <div className='row my-1'>
                            <div className="col-md-3 pe-0">
                                <label className='label'>Select Asset</label>
                                <div>
                                    <AssetDropDown onChange={AssestDDChanged} value={currentAsset} className="AssetDropDown input-default" data={AssetListDDL} />
                                </div>
                            </div>
                            <div className="col-md-9 text-end">
                                <button className='p-sm-btn mx-1' onClick={saveSelectedBM} disabled={!isEditable}>Save</button>
                                <button className="s-sm-btn mx-1" onClick={CancelButtonClick}> Cancel</button>
                            </div>

                        </div>
                        <div className='d-flex flex-column lineDiv my-1'>
                            <div className="row px-0 mx-0">
                                <div className="col-md-3 px-0">
                                    <Form.Control type="text" placeholder="Select Benchmark..." onKeyUp={changeSearchTerm} className='w-100 flex-grow-1 input-default' />
                                </div>
                            </div>
                        </div>
                        <div>
                        </div>
                    </div>
                    <div className='gridcontent d-flex flex-row mt-3' >
                        <div className='gridDiv' >
                            <div className=''>Available Benchmarks</div>
                            <div className="griddata ag-theme-alpine" style={{ height: '20rem' }}>
                                <AgGridReact
                                    columnDefs={totalBMcolDef}
                                    rowData={totalBM}
                                    defaultColDef={defaultColDef}
                                    onRowDoubleClicked={BMGridRowDoubleClicked}
                                    rowSelection={'single'}
                                    ref={TotalBMApi}
                                >
                                </AgGridReact>
                            </div>
                        </div>
                        <div className='d-flex flex-column justify-content-center px-3'>
                            <button className='p-sm-btn my-1' onClick={addBenchMark}>
                            <i class="fa-solid fa-arrow-right"></i>
                            </button>
                            <button className='p-sm-btn my-1' onClick={removeBenchMark}>
                            <i class="fa-solid fa-arrow-left"></i>
                            </button>

                        </div>
                        <div className='gridDiv'>
                            <div className=''>
                                Selected Benchmarks
                            </div>
                            <div className='griddata ag-theme-alpine' style={{ height: '20rem' }}>
                                <AgGridReact
                                    columnDefs={selectedBMcolDef}
                                    rowData={SelectedBM}
                                    defaultColDef={defaultColDef}
                                    onRowDoubleClicked={SBMGridRowDoubleClicked}
                                    rowSelection={'single'}
                                    ref={selectedBMApi}
                                    rowDragManaged={true}
                                    animateRows={true}
                                    onRowDragEnd={handleRowDragEnd}
                                    allowContextMenuWithControlKey={true}
                                    getContextMenuItems={getContextMenuItems}
                                    onGridReady={(params) => {
                                        params.api.sizeColumnsToFit()
                                    }}
                                    onRowDragLeave={handleRowDragEnd}
                                >
                                </AgGridReact>
                            </div>
                        </div>
                    </div>
                    <div className='footerContent row mt-3' >
                        <div className='col-md-4'>
                            <TypeSection name={"RFR Type"} VariableValue={RFRBM} radioName={"RfrType"} onEnter={getAdditionalBM} value={RFRValue} setValue={setRFRValue} asset={benchmarkEntities} />
                        </div>
                        <div className='col-md-4'>
                            <TypeSection name={"MAR Type"} VariableValue={MARBM} radioName={"MarType"} onEnter={getAdditionalBM} value={MARValue} setValue={setMARValue} asset={benchmarkEntities}/>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </>}
        </>
    )
}
export const AssetSetttingModal=({setShowModal,onSave})=>{
    const isEditable=useSelector(state=>state.authorizationData.isEditable);
    const params = useParams();
    const dispatch = useDispatch();
    // const history = useNavigate();
    const [torender, SetToRender] = useState(false);
    const [Loading, setLoading] = useState(true);
    const [SelectedBM, setSelectedBM] = useState([]);
    const [totalBM, setTotalBM] = useState([]);
    const [initalRender, setInitalRender] = useState(true);
    const selectedBMApi = useRef();
    const TotalBMApi = useRef();
    const [MARBM, setMARBM] = useState();
    const [RFRBM, setRFRBM] = useState();
  
    const [RFRValue, setRFRValue] = useState({
        isFixed: true, fValue: null, VariableValue: {
            "BenchmarkEntityId": 0,
            "BenchmarkEntityName": "",
            "BenchmarkEntityTypeId": 0,
            "BenchmarkEntityType": "",
            "StartDate": "",
            "EndDate": null
        }
    });
    const [MARValue, setMARValue] = useState({ isFixed: true, fValue: 0, VariableValue: {
        "BenchmarkEntityId": 0,
        "BenchmarkEntityName": "",
        "BenchmarkEntityTypeId": 0,
        "BenchmarkEntityType": "",
        "StartDate": "",
        "EndDate": null
    }});
    const [showbtn, setShowbtn] = useState(false);
    const [selectedentity, setSelectedentity] = useState();
   
    useEffect(() => {
        document.title = "Asset Settings";
        dispatch(getAssestListddlAction());
        dispatch(getAsset(params.Asset));
        dispatch(getAssetSettings(params.Asset,1));
    }, [torender]);

    //cancel Button
    const CancelButtonClick = () => {
        setShowModal(false);
        // history(`${UrlPath.AssetDetails}${params.Asset}`);
    };

    const Gstate = useSelector((state) => state);
    const currentAsset = Gstate.asset.asset;
    const AssetListDDL = useSelector(state => state.assetDDL.assetList);
    const AssetSettings = useSelector(state => state.assetSettings);
    const benchmarkEntities = AssetSettings.benchMarkEntities;
    const additionalBM = AssetSettings.additionalBM;
    const ASetting = AssetSettings.assetSetting || {};
    const assetBM = AssetSettings.assetSetting.Benchmarks || [];

    useEffect(() => {
    }, [assetBM])


    useEffect(() => {
        if (initalRender == true) {
            setInitalRender(false)
            return;
        }

        setTotalBM(() => benchmarkEntities);
        setRFRBM(() => additionalBM);
        setMARBM(() => additionalBM);
    }, [benchmarkEntities, additionalBM]); 
    
    useEffect(() => {
        setSelectedBM(assetBM.map((item, index) => {
            return { ...item , AssetId : parseInt(params.Asset)  ,"rowIndex": index ,EntityTypeId:1 ,BenchMarkXRefId :0 ,ModifiedBy :32 }
        }));
        setRFRValue({
            isFixed: ASetting.IsRFRFixedRate, fValue: ASetting.RFR, VariableValue: 
            {
                "BenchmarkEntityId": ASetting.RFRBenchmark,
                "BenchmarkEntityName": ASetting.RFRBenchmarkName,
                "BenchmarkEntityTypeId": ASetting.RFREntityTypeId,
                "BenchmarkEntityType": "",
                "StartDate": "",
                "EndDate": null
            }
        });
        setMARValue({
            isFixed: ASetting.IsMARFixedRate, fValue: ASetting.MAR, VariableValue: 
            {
                "BenchmarkEntityId": ASetting.MARBenchmark,
                "BenchmarkEntityName": ASetting.MARBenchmarkName,
                "BenchmarkEntityTypeId":  ASetting.MAREntityTypeId,
                "BenchmarkEntityType": "",
                "StartDate": "",
                "EndDate": null
            }
        });
    }, [ASetting]);

    useEffect(() => {
        (currentAsset && AssetListDDL && AssetSettings) && setLoading(false);
    }, [Gstate]);

    const AssestDDChanged = async (e) => {
        if (e.value) {
            // await e.value && history(`${UrlPath.AssetSetting}${e.value.AssetId}`);
            // await e.value && dispatch(getAsset(e.value.AssetId));
            // await e.value && dispatch(getAssetSettings(e.value.AssetId,1));
        }
    }
    const endDatevalueFormatter = (props) => {
        const date = props.data.EndDate;
        let monthName = "";
        let year = "";
        let convertedDate;
        let outPut = "";
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        if (date !== null) {
            convertedDate = new Date(date);
            monthName = monthNames[convertedDate.getMonth()];
            year = convertedDate.getFullYear();
            outPut = monthName + "-" + year;
        }
        return (
            <div>{outPut
            }</div>
        );
    };


    const startDatevalueFormatter = (props) => {
        const date = props.data.StartDate;
        let monthName = "";
        let year = "";
        let convertedDate;
        let outPut = "";
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        if (date !== null) {
            convertedDate = new Date(date);
            monthName = monthNames[convertedDate.getMonth()];
            year = convertedDate.getFullYear();
            outPut = monthName + "-" + year;
        }
        return (
            <div>{outPut
            }</div>
        );
    };
    const totalBMcolDef = [
        { field: "rowNumber", headerName: "", valueGetter: 'node.rowIndex+1', flex: 0.2 },
        { field: "BenchmarkEntityName", headerName: "Name", flex: 2, resizable: true },
        { field: "BenchmarkEntityType", headerName: "Entity Type" },
        { field: "StartDate", headerName: "Start Date", cellRenderer: startDatevalueFormatter },
        { field: "EndDate", headerName: "End Date", cellRenderer: endDatevalueFormatter },
    ];

    const selectedBMcolDef = [
        {
            rowDrag: true,
            field: "", headerName: "Selected", width: 110, valueGetter: function (params) {
                const rowIndex = params.node.rowIndex + 1;
                const IsPME = params.data.BenchMarkXRefTypeId == 4;
                if (rowIndex == 1) {
                    if (IsPME)
                        return "PME ";
                    else
                        return "Primary";
                }
                else if (rowIndex == 2) {
                    if (IsPME)
                        return "PME";
                    else
                        return "Secondary";
                }
                else {
                    if (IsPME)
                        return `PME`;
                    else
                        return `Addl BM ${rowIndex - 2}`;
                }
            },
            flex: 1.5
        },
        { field: "BMEntityName", headerName: "Name", flex: 2 },
        { field: "BenchmarkTypeName", headerName: "Entity Type", },
        { field: "StartDate", headerName: "Start Date", cellRenderer: startDatevalueFormatter, },
        { field: "EndDate", headerName: "End Date", cellRenderer: endDatevalueFormatter },
    ];

    const defaultColDef = {
        sortable: true, filter: true, flex: 1,resizable:true
    }
    const changeSearchTerm = (e) => {
        const search = e.filter.value;
        search.length > 0 && dispatch(getBenchmarkEntities(search, "benchMark"));
        search.length === 0 && setTotalBM([]);
    }
    const getAdditionalBM = (e) => {
        const search = e.filter.value;
        search.length > 3 && dispatch(getBenchmarkEntities(search, "AdditionalbenchMark"));
    }
    const addBenchMark = (e) => {     
        const newBenchMark = TotalBMApi.current.api.getSelectedRows();
        if(newBenchMark.length>0){
            newBenchMark && addSelectedBM(newBenchMark[0]);
        }
        // if (SelectedBM.length > 0) {
        //     let RepeatedBenchmark = [];
        //     SelectedBM.map((item) => {
        //         const newBenchMarklist = item;
        //         const BenchmarkEntityName = item.EntityName;
        //         if (newBenchMark.BenchmarkEntityId === newBenchMarklist.BMEntityId) {
        //             RepeatedBenchmark.push(`${BenchmarkEntityName}`);
        //         }
        //     })
        //     if (RepeatedBenchmark.length > 0) {
        //         let ErrorString = "";
        //         RepeatedBenchmark.map((item, i) => {
        //             ErrorString = `${ErrorString}  ${item} ,  `;
        //         });
        //         ErrorString = `${ErrorString} already Exists`;
        //         toast.error(ErrorString, {
        //             position: "top-right",
        //             autoClose: 5000,
        //             hideProgressBar: false,
        //             closeOnClick: true,
        //             pauseOnHover: false,
        //             draggable: true,
        //             progress: undefined,
        //             theme: "light",
        //         });
        //     }
        //     else {
        //         newBenchMark && addSelectedBM(newBenchMark);
        //     }

        // }
    }
    const addSelectedBM = (newBenchMark) => {
        const toAdd = {
            'rowIndex': SelectedBM.length,
            "AssetId": parseInt(params.Asset),
            "BenchMarkXRefId": 0,
            "BenchMarkXRefTypeId": 0,
            "BenchmarkTypeName": newBenchMark.BenchmarkEntityType,
            "EntityTypeId": 1,
            "EntityTypeName": null,
            "EntityId": parseInt(params.Asset),
            "BMEntityName": newBenchMark.BenchmarkEntityName,
            "IsFixedRate": false,
            "BMEntityTypeId": newBenchMark.BenchmarkEntityTypeId,
            "BMEntityTypeName": newBenchMark.BenchmarkEntityType,
            "BMRanking": "primary",
            "BMEntityId": newBenchMark.BenchmarkEntityId,
            "BMValue": 0,
            "IsMrktEqBM": false,
            "SortOrder": SelectedBM.length,
            "StartDate": newBenchMark.StartDate,
            "EndDate": newBenchMark.EndDate,
            "RFRBenchmark": null,
            "RFRBenchmarkName": null,
            "MARBenchmark": null,
            "MARBenchmarkName": null,
            "RFR": null,
            "MAR": null,
            "ModifiedBy": 32,
            "ModifiedByName": null,
            "ModifiedDate": (new Date()).toISOString,
        };
        if(SelectedBM.length<10)
        {
        setSelectedBM((pv) => {
        return [...pv, { ...toAdd }] });
        }
        else
        {   
            toast.error("Cannot add more than 10 benchmarks", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
    }
    const removeSelectedBM = (benchMark) => {
        setSelectedBM(pv => ((pv.filter(item => item.rowIndex !== benchMark.rowIndex).map((item, index) => { return { ...item, rowIndex: index, SortOrder: index } }))));
    }
    const BMGridRowDoubleClicked = (e) => {
        addSelectedBM(e.data);
    }
    const removeBenchMark = () => {
        const BenchMark = selectedBMApi.current.api.getSelectedRows()[0];
        BenchMark && removeSelectedBM(BenchMark);
    }
    const SBMGridRowDoubleClicked = (row) => {
        removeSelectedBM(row.data);
    }
    let Level = [{ BreadCrumb: "Asset > ", Routes: `${UrlPath.Asset}` }];
    Level = Loading ? Level : [...Level, { BreadCrumb: `${currentAsset.AssetName} >`, Routes: `${UrlPath.AssetDetails}${params.Asset}` }, { BreadCrumb: `Settings`, Routes: `${UrlPath.AssetSetting}${params.Asset}` }];

    const handleRowDragEnd = (params) => {
        // console.log(params,selectedBMApi.current.props.rowData,'params');
        // const rows = [];
        // selectedBMApi.current.api.forEachNodeAfterFilterAndSort((node,index) => {
        //     // node.data.rowIndex=index;
        //     // if(node.data.sortOder!==0)
        //     // {
        //     // node.data.SortOrder=index;
        //     // }
        //     rows.push(node.data)}
        //     );
        //     setSelectedBM(rows);
        const rows = [];
        selectedBMApi.current.api.forEachNodeAfterFilterAndSort((node) => rows.push(node.data));
        const OrderedRows=rows.map((data,index)=>{
            if(data.BenchMarkXRefTypeId===4)
            {
            data.rowIndex=99; 
            data.SortOrder=99;
            }
            else
            {
            data.rowIndex=index; 
            data.SortOrder=index;
            }
            return{...data}
            }).sort((a, b) => a.rowIndex - b.rowIndex) 
        setSelectedBM(OrderedRows);
    };
    const saveSelectedBM = async () => {
        let saveSuccess = true;
        let errorMsg = [];
        let bmItems = [...SelectedBM];
        bmItems.push({
            "rowIndex": 11,
            "AssetId": parseInt(params.Asset),
            "BenchMarkXRefId": 0,
            "BenchMarkXRefTypeId": 1,
            "BenchmarkTypeName": null,
            "EntityTypeId": 1,
            "EntityTypeName": null,
            "EntityId": parseInt(params.Asset),
            "EntityName": null,
            "IsFixedRate": RFRValue.isFixed,
            "BMEntityTypeId": RFRValue.isFixed ? 0 : RFRValue.VariableValue.BenchmarkEntityTypeId ,
            "BMEntityTypeName": RFRValue.isFixed ? 0 : RFRValue.VariableValue.BenchmarkEntityType,
            "BMRanking": null,
            "BMEntityId": RFRValue.isFixed ? 0 : RFRValue?.VariableValue?.BenchmarkEntityId,
            "BMEntityName": RFRValue.isFixed ? 0 : RFRValue?.VariableValue?.BenchmarkEntityName,
            "BMValue": RFRValue.isFixed ? parseFloat(RFRValue.fValue) : 0,
            "IsMrktEqBM": false,
            "SortOrder": 0,
            "StartDate": null,
            "EndDate": null,
            "RFRBenchmark": null,
            "RFRBenchmarkName": null,
            "MARBenchmark": null,
            "MARBenchmarkName": null,
            "RFR": null,
            "MAR": null,
            "ModifiedBy": 32,
            "ModifiedByName": null,
            "ModifiedDate": (new Date()).toISOString,
        });
        bmItems.push({
            "rowIndex": 12,
            "AssetId": parseInt(params.Asset),
            "BenchMarkXRefId": 0,
            "BenchMarkXRefTypeId": 2,
            "BenchmarkTypeName": null,
            "EntityTypeId": 1,
            "EntityTypeName": null,
            "EntityId": parseInt(params.Asset),
            "EntityName": null,
            "IsFixedRate": MARValue.isFixed,
            "BMEntityTypeId": MARValue.isFixed ? 0 : MARValue.VariableValue.BenchmarkEntityTypeId,
            "BMEntityTypeName": MARValue.isFixed ? 0 : MARValue.VariableValue.BenchmarkEntityType,
            "BMRanking": null,
            "BMEntityId": MARValue.isFixed ? 0 :  MARValue?.VariableValue?.BenchmarkEntityId,
            "BMEntityName": MARValue.isFixed ? 0 : MARValue?.VariableValue?.BenchmarkEntityName,
            "BMValue": MARValue.isFixed ? parseFloat(MARValue.fValue) : 0,
            "IsMrktEqBM": false,
            "SortOrder": 0,
            "StartDate": null,
            "EndDate": null,
            "RFRBenchmark": null,
            "RFRBenchmarkName": null,
            "MARBenchmark": null,
            "MARBenchmarkName": null,
            "RFR": null,
            "MAR": null,
            "ModifiedBy": 32,
            "ModifiedByName": null,
            "ModifiedDate": (new Date()).toISOString,
        });
        const newArray = bmItems.map(item => {
            return {
                "assetId": item.AssetId,
                "benchMarkXRefId": item.BenchMarkXRefId || 0,
                "benchMarkXRefTypeId": item.BenchMarkXRefTypeId || 0,
                "entityTypeId": item.EntityTypeId || 0,
                "entityId": item.EntityId || 0,
                "isFixedRate": item.IsFixedRate,
                "bmEntityTypeId": item.BMEntityTypeId || 0,
                "bmEntityId": item.BMEntityId || 0,
                "bmValue": item.BMValue || 0,
                "isMrktEqBM": item.IsMrktEqBM,
                "sortOrder": item.SortOrder || 0,
                "modifiedBy": item.ModifiedBy
            }

        });
        if (SelectedBM.length === 0) {
            saveSuccess = false;
            errorMsg.push("Please Select atleast one BenchMark");
        }
        if (RFRValue.isFixed) {
            if (RFRValue.fValue == null || RFRValue.fValue == "") {
                saveSuccess = false;
                errorMsg.push("Plesse Add RFR Type Value");
            }
        }
        else if (!RFRValue.isFixed) {
            if (!RFRValue.VariableValue.BenchmarkEntityId || RFRValue.VariableValue.BenchmarkEntityId === 0 ) {
                saveSuccess = false;
                errorMsg.push("Plesse Add RFR Variable Value");
            }
        }
        if (MARValue.isFixed) {
            if (MARValue.fValue == "" || MARValue.fValue == null) {
                saveSuccess = false;
                errorMsg.push("Plesse Add MAR Type Value");
            }
        }
        else if (!MARValue.isFixed) {
            if (!MARValue.VariableValue.BenchmarkEntityId || MARValue.VariableValue.BenchmarkEntityId === 0) {
                saveSuccess = false;
                errorMsg.push("Plesse Add MAR Variable Value");
            }
        }

        if (saveSuccess) {
            await sbaAxios({
                url: `${DeleteAssetBMSetting}${params.Asset},1`,
                method: 'get',
            }).then(response => {
            })
                .catch(error => {
                    console.error('Error deleting data:', error);
                });  
                await sbaAxios({
                    url: `${InsertAssetBMSetting}`,
                    method: 'post',
                    data: newArray,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }).then((response) => {
                    setTimeout(() => {
                        onSave();                        
                    }, 1000);
                    toast.success('Benchmark Added Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                }).catch((error) => { console.log(error) });
                setTimeout(() => {
                    setShowModal(false);
                    // history(`${UrlPath.AssetDetails}${params.Asset}`);
                  }, 1000);
        }
        else {
            toast.error(errorMsg.join("\n "), {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
    };
    const setPME = (rowIndex) => {
        let sortOder = -1;
        const updatedBM= SelectedBM.map(item => {
            if (item.rowIndex == rowIndex)
                return {
                    ...item, BenchMarkXRefTypeId: 4,rowIndex:99 ,SortOrder: 99
                }
            else {
                sortOder++;
                return { ...item, BenchMarkXRefTypeId: 0, SortOrder: sortOder , rowIndex:sortOder }
            }
        }).sort((a, b) => a.rowIndex - b.rowIndex);
        setSelectedentity(val=>null);
       // setRefresh(val=>!val);
        setSelectedBM(updatedBM);
        setShowbtn(false);
    }
    const removePME = (rowIndex) => {
        const updatedBM=SelectedBM.map((item,index) => {
                return { ...item, BenchMarkXRefTypeId: 0, SortOrder: index }
        }).sort((a, b) => a.SortOrder - b.SortOrder)
        setSelectedentity(val=>null);
       // setRefresh(val=>!val);
        setSelectedBM(updatedBM);
        setShowbtn(false);
    }
    const getContextMenuItems = (params) => {
        const rowIndex = params.node.data.rowIndex;
        const isPME = params.node.data.BenchMarkXRefTypeId === 4;
        var setPMEMenu = [
            {
                name: 'Set PME',
                action: () => {
                    setPME(rowIndex);
                },
                cssClasses: ['benchmark', 'highlight', 'bold'],
            },
        ];
        var removePMEMenu = [
            {
                name: 'Set BM',
                action: () => {
                    removePME(rowIndex);
                },
                cssClasses: ['benchmark', 'highlight', 'bold'],
            },
        ];
        if (isPME)
            return removePMEMenu;
        else
            return setPMEMenu;
    };
    const handleDragStart = (e, dragIndex) => {
        e.dataTransfer.setData("dragIndex", dragIndex);
    };
    const handleDragOver = (e) => {
        e.preventDefault(); 
    };
    const handleDrop = (e, dropIndex) => {
        e.preventDefault();
        const dragIndex = parseInt(e.dataTransfer.getData("dragIndex"), 10);
        if (dragIndex === dropIndex) return; 
        let updatedList = [...SelectedBM];
        const [movedItem] = updatedList.splice(dragIndex, 1); 
        updatedList.splice(dropIndex, 0, movedItem); 
        updatedList = updatedList.map((item, index) => ({
            ...item,
            SortOrder: item.BenchMarkXRefTypeId===4?99:index, 
        }));
        setSelectedBM(updatedList);
    };
    const columns = [
        {
            field: "BenchmarkEntityName",
            header: "Name",
            width: '300px',             
    },
        { field: "BenchmarkEntityType", header: "Type", width: '100px' }
    ];
    const handleClick = (item) => { 
        setSelectedentity(item.BMEntityName);
        setShowbtn(true);
    };
    const getClassName=(rowIndex, IsPME)=> {

        if (rowIndex === 0) {
           
          return IsPME ? "custom-pmebox " : "custom-gbox";
        } else if (rowIndex === 1) {
          return IsPME ? "custom-pmebox " : "custom-secbox";
        } else {
          return IsPME ? "custom-pmebox " : "custom-ybox";
        }
    };
    console.log(selectedentity,'1234567890')
    return (<>
        <div className='d-flex flex-column lineDiv my-1'>
            <div className="row px-0 mx-0">
                <div className="col-md-6 px-1">
                    <label className='label my-1'>Benchmark</label>
                    <SBAMultiColumnComboBox
                        data={totalBM}
                        value={null}
                        columns={columns}
                        filterable={true}
                        textField="BenchmarkEntityName"
                        valueField="BenchmarkEntityId"
                        onFilterChange={changeSearchTerm}
                        popupSettings={{ className: 'modalDD' }}
                        onChange={(e) => { addSelectedBM(e.value)}}
                        placeholder={'Select Benchmark...'}
                    />
                </div>
                <div className="col-md-6 px-1">
                    <label className='label my-1'>Set Primary</label>
                    <SBAComboBox  
                    placeholder="Set Primary..."   
                    popupSettings={{ className: 'modalDD' }}
                    data={SelectedBM}
                    value={SelectedBM[0]}
                    disabled
                    textField="BMEntityName"
                    valueField="BMEntityId"
                    
                    />
                </div>
            </div>
            <div className="d-flex my-2 scrollable-div">
                {SelectedBM.map((item,index) => {
                    const IsPME = item.BenchMarkXRefTypeId == 4;
                    return (
                        <span
                            key={item.BMEntityName}
                            className= {getClassName(item.SortOrder,IsPME)}
                            draggable="true"
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDrop={(e) => handleDrop(e, index)}
                            onClick={() => handleClick(item)}
                            onMouseLeave={() => {setSelectedentity(null)}}

                        >
                            {item.BMEntityName}
                            {selectedentity && item.BMEntityName === selectedentity && (
                                <button
                                    className="mx-3 px-2"
                                    onClick={() =>item.BenchMarkXRefTypeId === 4?removePME(item.rowIndex):setPME(item.rowIndex)}
                                >
                                    {item.BenchMarkXRefTypeId === 4?"Set BM":"Set PME"}
                                </button>
                            )}
                            <i className="fa-solid fa-close SBA_hand mx-1" onClick={() => removeSelectedBM(item)} />
                        </span>
                    );
                })}               
           </div>
        </div>
        <div>
            <TypeSection name={"RFR Type"} VariableValue={RFRBM} radioName={"RfrType"} onEnter={getAdditionalBM} value={RFRValue} setValue={setRFRValue} asset={benchmarkEntities} />
        </div>
        <div>
            <TypeSection name={"MAR Type"} VariableValue={MARBM} radioName={"MarType"} onEnter={getAdditionalBM} value={MARValue} setValue={setMARValue} asset={benchmarkEntities} />
        </div>
        <div className="d-flex align-items-center my-4">
  <div className="box green mx-2 ">Primary</div>
  <div className="box grey mx-2">Secondary</div>
  <div className="box blue mx-2">PME</div>
  <div className="box yellow mx-2">Additional BM</div>
  <button className="s-sm-btn mx-2 ms-auto" onClick={CancelButtonClick}>Cancel</button>
  <button className="p-sm-btn mx-2" onClick={saveSelectedBM} disabled={!isEditable}>Save</button>
</div>

                           
    </>)
}
const TypeSection = ({ name, VariableValue, radioName, value, setValue }) => {
    const [selectedEntity,setSelectedEntity]=useState(value.VariableValue);
    useEffect(() => {
        setSelectedEntity(value.VariableValue);
       
    })
    const [enityDS,setEntityDS]=useState([]);
    const setCurrentData = (e) => {
        const blankEntity={
            "BenchmarkEntityId": 0,
            "BenchmarkEntityName": "",
            "BenchmarkEntityTypeId": 0,
            "BenchmarkEntityType": "",
            "StartDate": "",
            "EndDate": null
        }
        if (e.value) {
            setSelectedEntity(e.value)
            setValue({ ...value, VariableValue: e.value });
        }
       
    };
    const fixedValueChanged = (e) => {
        setValue({ ...value, fValue: e.target.value });
    };
    const radioButtonChanged = () => {
        setValue({ ...value, isFixed: !value.isFixed });
    };
    const getEnities=(e)=>{
        if(e.filter.value)
        {
            const textValue=e.filter.value;
            if(textValue.length>1)
            {
                sbaAxios({ url: `${getBenchmarkEntity}${textValue}`, method: 'get' }).then(response => {
                    setEntityDS(response);
                }).catch(error => {
                  console.log(error, 'error fetching universe List');
                });
            }
        }
        else {
            setEntityDS([]);
        }
        // if(e.syntheticEvent.type==="click")
        // {
        // //     debugger;
        // //   const selectedDataItem = universeList.find(item => item.EntityName === e.target.value);
        // //   dispatch(getUniverseMembersAction(selectedDataItem.EntityId , null));
        // //   setShowGridValue(true);
    
        // }
    }

    return (
        <div className='d-flex flex-column footerItem px-4'>
            <label className='label my-2'>{name} </label>
            <div className='d-flex flex-row '>
                <div className='d-flex flex-column w-50' >
                    <span className='my-1' >
                        <input type='radio' name={radioName} checked={value.isFixed} onChange={radioButtonChanged} /><label className='label ms-3'>Fixed</label>
                    </span>
                    <span className='d-flex flex-row' >
                        <Form.Control type="number" placeholder="" defaultValue={value.fValue||""} disabled={!value.isFixed} className="w-75 input-default" onKeyUp={fixedValueChanged} /><span className="mx-1">%</span>
                    </span>
                </div>
                <div className='d-flex flex-column w-50' >
                    <span className='my-1'>
                        <input type='radio' name={radioName} checked={!value.isFixed} onChange={radioButtonChanged} /><label className='label ms-3'>Variable</label>
                    </span>
                    <span className='d-flex flex-row my-2' >
                        <SBAComboBox data={enityDS} textField={'BenchmarkEntityName'} valueField={'BenchmarkEntityId'}
                            value={selectedEntity}
                            onChange={setCurrentData} disabled={value.isFixed}
                            onFilterChange={(e)=>getEnities(e)}
                            popupSettings={{ className: 'modalDD' }}
                            className="w-75"
                        />

                    </span>
                </div>
            </div>
        </div>
    )
}
